


export class ZZPOMON {
  "prNumber";
  "reqLine";
  "purchasingDocument";
  "poItem";
  "network";
  "serviceOrder";
  "costCenter";
  "poCreateDate";
  "poDeletionIndicator";
  "qtyOrdered";
  "netPrice";
  "currKey";
  "materialNo";
  "shortText";
  "vendorNo";
  "vendorName";
  "requisitioner";
  "createdBy";
  "reqTrackingNo";
  "siteId";
  "grQty";
  "movementType";
  "grDocNo";
  "goodsReceiptDate";
  "irQty";
  "irDocNo";
  "invoiceReceiptDate";
  "overallLineStatus";
  "poItemCategoryMe23N";
  "grToBeDone";
  "irToBeDone";
  "deliveryDatePo";
  "plant";
  "storageLocation";
  "porg";
  "releaseStrategy";
  "documentNumberMkpf";
  "releaseIndicator";
  "delComInd";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ZZPOMON`.
   */
  static getModelName() {
    return "ZZPOMON";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ZZPOMON for dynamic purposes.
  **/
  static factory(data) {
    return new ZZPOMON(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'ZZPOMON',
      plural: 'ZZPOMONs',
      path: 'ZZPOMONs',
      properties: {
        "prNumber": {
          name: 'prNumber',
          type: 'string'
        },
        "reqLine": {
          name: 'reqLine',
          type: 'string'
        },
        "purchasingDocument": {
          name: 'purchasingDocument',
          type: 'string'
        },
        "poItem": {
          name: 'poItem',
          type: 'string'
        },
        "network": {
          name: 'network',
          type: 'string'
        },
        "serviceOrder": {
          name: 'serviceOrder',
          type: 'string'
        },
        "costCenter": {
          name: 'costCenter',
          type: 'string'
        },
        "poCreateDate": {
          name: 'poCreateDate',
          type: 'string'
        },
        "poDeletionIndicator": {
          name: 'poDeletionIndicator',
          type: 'string'
        },
        "qtyOrdered": {
          name: 'qtyOrdered',
          type: 'string'
        },
        "netPrice": {
          name: 'netPrice',
          type: 'string'
        },
        "currKey": {
          name: 'currKey',
          type: 'string'
        },
        "materialNo": {
          name: 'materialNo',
          type: 'string'
        },
        "shortText": {
          name: 'shortText',
          type: 'string'
        },
        "vendorNo": {
          name: 'vendorNo',
          type: 'string'
        },
        "vendorName": {
          name: 'vendorName',
          type: 'string'
        },
        "requisitioner": {
          name: 'requisitioner',
          type: 'string'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "reqTrackingNo": {
          name: 'reqTrackingNo',
          type: 'string'
        },
        "siteId": {
          name: 'siteId',
          type: 'string'
        },
        "grQty": {
          name: 'grQty',
          type: 'string'
        },
        "movementType": {
          name: 'movementType',
          type: 'string'
        },
        "grDocNo": {
          name: 'grDocNo',
          type: 'string'
        },
        "goodsReceiptDate": {
          name: 'goodsReceiptDate',
          type: 'string'
        },
        "irQty": {
          name: 'irQty',
          type: 'string'
        },
        "irDocNo": {
          name: 'irDocNo',
          type: 'string'
        },
        "invoiceReceiptDate": {
          name: 'invoiceReceiptDate',
          type: 'string'
        },
        "overallLineStatus": {
          name: 'overallLineStatus',
          type: 'string'
        },
        "poItemCategoryMe23N": {
          name: 'poItemCategoryMe23N',
          type: 'string'
        },
        "grToBeDone": {
          name: 'grToBeDone',
          type: 'string'
        },
        "irToBeDone": {
          name: 'irToBeDone',
          type: 'string'
        },
        "deliveryDatePo": {
          name: 'deliveryDatePo',
          type: 'string'
        },
        "plant": {
          name: 'plant',
          type: 'string'
        },
        "storageLocation": {
          name: 'storageLocation',
          type: 'string'
        },
        "porg": {
          name: 'porg',
          type: 'string'
        },
        "releaseStrategy": {
          name: 'releaseStrategy',
          type: 'string'
        },
        "documentNumberMkpf": {
          name: 'documentNumberMkpf',
          type: 'string'
        },
        "releaseIndicator": {
          name: 'releaseIndicator',
          type: 'string'
        },
        "delComInd": {
          name: 'delComInd',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ZZPOMON.js